import { useEffect, useMemo, useState } from "react";

import { usePostHog } from "posthog-js/react";

import { UseGetFlag } from "../app/launchDarkly";

const usePostHogRecordingGlobal = (currentIndex: number) => {
    const { posthogSessionReplay } = UseGetFlag()
    const posthog = usePostHog();
    const isRecording = posthog.sessionRecording?.started

    const enableTiggerRecord: boolean = useMemo(() => posthogSessionReplay, [posthogSessionReplay])
    useEffect(() => {
        if (enableTiggerRecord && !isRecording && currentIndex === 0) {
            posthog.startSessionRecording()

        }

        if (!enableTiggerRecord) {
            posthog.stopSessionRecording()

        }

    }, [enableTiggerRecord, posthog, currentIndex, isRecording]);

    return null

}
export default usePostHogRecordingGlobal